import { useState } from "react";
import "./App.css";
import Nav from "./Component/Layout/Nav";
import CourseCards from "./Component/CourseCards";
import LoginForm from "./Component/LoginForm";
import VartmanNiryanCards from "./Component/VartmanNiryanCards"; // Import the component
import { BrowserRouter as Router } from "react-router-dom";

function App() {
  const [activeComponent, setActiveComponent] = useState("courses"); // Default to "courses"

  return (
    <Router>
      <div className="App">
        <Nav 
          onRegisterClick={() => setActiveComponent("courses")} 
          onLoginClick={() => setActiveComponent("login")} 
          onVartmanNiryanClick={() => setActiveComponent("vartmanNiryan")} 
        />

        {/* Conditionally render only one component at a time */}
        {activeComponent === "courses" && <CourseCards />}
        {activeComponent === "login" && <LoginForm onClose={() => setActiveComponent(null)} />}
        {activeComponent === "vartmanNiryan" && <VartmanNiryanCards />}
      </div>
    </Router>
  );
}

export default App;
